/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Gap,
  Typography,
  Button,
  Dialog,
  SelectField,
  Col,
  Row,
  Box,
  Flex,
  Divider,
  InputField,
  Switchbox,
  Avatar,
} from "../../../ppui";
import {
  AllowanceBox,
  ContentHeading,
  ContentLayout,
  ContentTable,
  HeaderBorder,
  ImportAttendance,
} from "../../style";
import { TbCalendarFilled, TbCloudUpload, TbUserEdit } from "react-icons/tb";
import GlobalTable from "../../../components/global-table";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { AttendanceHeaders } from "./attendance.data";
import useAttendenceService from "./attendance-service";
import { useAuthContext } from "../../../context/authContext";
import { logger } from "../../../utils/logger";

const OtTracking = ({ openSnackbar }) => {
  const { orgDetails } = useAuthContext()
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const [isLoading, setIsLoading] = useState(false)


  const {
    getEmployeeData,
    exportToCSV,
    handleChoosenMonth,
    monthOptions,
    errorMessage,
    handleChoosenYear,
    yearOptions,
    uploadCSVData,
    attendanceSummeryLists,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    rowsPerPage,
    currentPage,
    totalPages,
    searchQuery,
    setSearchQuery,
    generateAttendance,
    getAttendenceSummeryLists,
    count, setCount,
    isApproved,
    approvedOT
  } = useAttendenceService({ openSnackbar, selectedMonth, selectedYear })

  // State for each modal's visibility
  const [openAttendanceModal, setOpenAttendanceModal] = useState(false);
  const [openUploadImportModal, setOpenUploadImportModal] = useState(false);

  // Details modal
  const handleOpenAttendanceModal = () => {
    setOpenAttendanceModal(true)
    setFileName("")
    handleChoosenYear(orgDetails.date_of_org)
    setErrorList([]);
  };

  const handleCloseAttendanceModal = () => {
    getAttendanceTitle(selectedMonth, selectedYear);
    setFileName("")
    setOpenAttendanceModal(false);
    setErrorList([]);
  }

  const handleOpenUploadImportModal = () => setOpenUploadImportModal(false);
  const handleCloseUploadImportModal = () => setOpenUploadImportModal(false);

  // Upload-file



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === "text/csv") {
        setFileName(file.name);
        setFile(file)
      } else {
        openSnackbar({ message: "Please upload a valid .csv file", color: "danger" })
      }
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];
    if (file) {
      if (file.type === "text/csv") {
        setFileName(file.name);
      } else {
        openSnackbar({ message: "Please upload a valid .csv file", color: "danger" })
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => setIsDragging(false);

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
    handleChoosenMonth(value, orgDetails.date_of_org)
  };

  const handleExport = async () => {
    const data = await getEmployeeData(selectedMonth, selectedYear);

    if (errorMessage) {
      openSnackbar({ message: errorMessage, color: "danger" });
    }

    if (data) {
      exportToCSV(data);
    }
  };

  const handleImportAttendance = async () => {
    setIsLoading(true)
    const response = await uploadCSVData(file, selectedMonth, selectedYear)
    setCount(1)
    if (Array.isArray(response) && response.every(item => typeof item === "string")) {
      setIsLoading(false)
      setErrorList(response);
    } else {
      setIsLoading(false)
      openSnackbar({ message: "Ot import successfully.", color: "success" })
      handleCloseAttendanceModal()
    }
  }

  const getAttendanceTitle = (selectedMonth, selectedYear) => {
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];

    if (selectedMonth && selectedYear) {
      return `of ${monthNames[selectedMonth - 1]}, ${selectedYear}`;
    }

    return "";
  };


  useEffect(() => {
    if (selectedMonth && selectedYear && count > 0) {
      getAttendanceTitle(selectedMonth, selectedYear);
      getAttendenceSummeryLists(selectedMonth, selectedYear)
    }
  }, [selectedMonth, selectedYear, count]);


  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Overtime {count > 0 && getAttendanceTitle(selectedMonth, selectedYear)}
          </Typography>
          {!isApproved && (
            <Button
              color="primary" variant="contained"
              onClick={() => { approvedOT(selectedMonth, selectedYear); }}
            >
              Approved OT
            </Button>
          )}


        </ContentHeading>
        <ContentTable>
          <GlobalTable
            headers={AttendanceHeaders}
            rows={attendanceSummeryLists}
            ActiveSort={false}
            searchBox={true}
            columnManagement={true}
            avatar={true}
            stickyHeader="true"
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalPages={totalPages}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            // FetchDataFromRow={FetchDataFromRow}
            FetchDataFromRow={(row) => handleOpenUploadImportModal(row)}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}

            actionRight={
              <>

              </>
            }
            actionLeft={
              <>

                <Button onClick={handleOpenAttendanceModal} variant="outlined" icon={<TbCalendarFilled />}>
                  {(selectedMonth && selectedYear) ?
                    "Change OT Month" : "Generate OT"
                  }
                </Button>

              </>
            }
          />

        </ContentTable>
      </ContentLayout>

      {/* ImportModal */}
      <Dialog
        title={!errorList.length > 0 ? "Generate Ot" : "Ot Errors List"}
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={openAttendanceModal}
        onClose={handleCloseAttendanceModal}
        onSubmit={() => alert("Submitted")}
        action={false}
        separator
        bodyScroll
      >
        {!errorList.length > 0 ? (
          <>
            <Row>
              <Col sm={6}>
                <SelectField
                  fullWidth
                  label="Choose a year"
                  options={yearOptions}
                  placeholder="Select Here..."
                  onChange={(e) => handleYearChange(e)}
                />
              </Col>
              <Col sm={6}>
                <SelectField
                  fullWidth
                  label="Choose a month"
                  disabled={!selectedYear}
                  options={monthOptions}
                  placeholder="Select Here..."
                  onChange={(e) => handleMonthChange(e)}
                />
              </Col>
            </Row>
            <Gap height={40} />
            <ImportAttendance
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              align="center"
              p={4}
              border="1px dashed #ccc"
              borderRadius="8px"
              bgcolor={isDragging ? "#f0f0f0" : "transparent"}
              width="100%"
              style={{ cursor: "pointer" }}
            >
              <Flex direction={"column"}>
                <Box align="center" mb={10}>
                  <Avatar icon={<TbCloudUpload />} size="lg" variant="outlined" />
                </Box>
                <Box>
                  <Typography color="primary" variant="h5" mb="15" align="center">
                    Choose a file or drag & drop it here
                  </Typography>
                  <Typography variant="h6" mb="0" align="center">
                    Only .csv files, up to 5MB
                  </Typography>
                  <input
                    type="file"
                    id="fileInput"
                    style={{ display: "none" }}
                    accept=".csv"
                    onChange={handleFileChange}
                  />
                  <Box mt="20" align="center">
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => document.getElementById("fileInput").click()}
                    >
                      Browse File
                    </Button>
                  </Box>
                </Box>
                {fileName && (
                  <Box mt="20" align="center">
                    <Typography variant="body2" color="secondary" align="center">
                      Selected File: {fileName}
                    </Typography>
                  </Box>
                )}
              </Flex>
            </ImportAttendance>
            <Gap height={40} />
            {
              selectedMonth && selectedYear && <>
                <Row rowGap alignItem={"center"}>
                  <Col sm={12} md={4} lg={8}>
                    <Flex gap={20} alignItem={"center"}>
                      <Box>
                        <Avatar shape="square" icon={<BsFileEarmarkPdfFill />} />
                      </Box>
                      <Box>
                        <Typography variant="body2" mb={"0"} color={"dark"}>
                          {`Sample copy of import Ot file.`}
                        </Typography>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Flex gap={10}>
                      <Button
                        onClick={handleExport}
                        variant="filled"
                        size="sm"
                        color="danger"
                      >
                        Download
                      </Button>
                    </Flex>
                  </Col>
                </Row>
                <Gap height={40} />
              </>
            }

            <Row specing={"40"}>
              <Col xs="12" sm="6">
                <Button
                  onClick={handleImportAttendance}
                  color="primary"
                  fullWidth
                  variant="filled"
                  loading={isLoading}
                  disabled={!(fileName && selectedMonth && selectedYear)}
                >
                  Import Ot
                </Button>
              </Col>
              <Col xs="12" sm="6">
                <Button
                  color="primary"
                  fullWidth
                  variant="contained"
                  onClick={() => { generateAttendance(selectedMonth, selectedYear); setCount(1); handleCloseAttendanceModal() }}
                  disabled={!(selectedMonth && selectedYear)}
                >
                  View Overtime

                </Button>
              </Col>
            </Row>
          </>) : (
          <>
            <Box>

              <ol>
                {errorList.map((item, index) => (
                  <li key={index}>{JSON.stringify(item)}</li>
                ))}
              </ol>
            </Box>
            <Gap height={40} />
            <Row specing={"40"} justifyContent="center">
              <Col xs="12" sm="6">
                <Button
                  color="primary"
                  fullWidth
                  variant="contained"
                  onClick={generateAttendance}
                >
                  Tryagain
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Dialog>
      {/* ImportModal */}

      {/* UploadImportModal */}
      <Dialog
        title="Attendance Details"
        closeButton={true}
        fullWidth
        maxWidth="lg"
        buttonName={"Submit"}
        open={openUploadImportModal}
        onClose={handleCloseUploadImportModal}
        onSubmit={() => alert("Submitted")}
        separator
        footer={
          <Box mr={"auto"}>
            <Switchbox
              label="Not work for full month"
              color="Primary"
              size="lg"
            />
          </Box>
        }
      >
        <Box Padding>
          <Row alignItem="center">
            <Col sm={12}>
              <Row alignItem="center">
                <Col sm={"auto"}>
                  {/* <PhotoUpload>
                    <TbUserEdit />
                  </PhotoUpload> */}
                  <Avatar size="lg" icon={<TbUserEdit />} />
                </Col>

                <Col sm={2}>
                  <HeaderBorder>
                    <Typography variant="h6" mb={10}>
                      Jeet Sengupta
                    </Typography>
                    <Typography variant="body2">EMP524215423</Typography>
                  </HeaderBorder>
                </Col>

                <Col sm={2}>
                  <HeaderBorder>
                    <Typography variant="body1" mb={"0"}>
                      Designation
                    </Typography>
                    <Typography variant="body2" mb={"0"}>
                      Manager
                    </Typography>
                  </HeaderBorder>
                </Col>

                <Col sm={2}>
                  <HeaderBorder>
                    <Typography variant="body1" mb={"0"}>
                      Contact Number
                    </Typography>
                    <Typography variant="body2" mb={"0"}>
                      +91 96523 45782
                    </Typography>
                  </HeaderBorder>
                </Col>

                <Col sm={3}>
                  <Typography variant="body1" mb={"0"}>
                    Email ID
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    pankaj_kumar@gmail.com
                  </Typography>
                </Col>
              </Row>
            </Col>
          </Row>
        </Box>
        <Divider gap={20} />

        {/* <Gap height={30} /> */}
        <Flex gap={20} direction={"column"}>
          <AllowanceBox>
            <Row alignItems="center">
              <Col>
                <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                  <Box>
                    <Box className="label">Month</Box>
                    <Box className="value">31</Box>
                  </Box>
                  <Box>
                    <Box className="label">SOW </Box>
                    <Box className="value">30</Box>
                  </Box>
                  <Box>
                    <Box className="label">Holidays </Box>
                    <Box className="value">1</Box>
                  </Box>
                  <Box>
                    <Box className="label">Weekly Off</Box>
                    <Box className="value">0</Box>
                  </Box>
                  <Box>
                    <Box className="label">LWP</Box>
                    <Box className="value">30</Box>
                  </Box>
                  <Box>
                    <Box className="label">Total Leave</Box>
                    <Box className="value">30</Box>
                  </Box>

                  <Box>
                    <Box className="label">Payable</Box>
                    <Box className="value">1</Box>
                  </Box>

                  <Box>
                    <Box className="label">NCP</Box>
                    <Box className="value">17</Box>
                  </Box>
                </Flex>
              </Col>
            </Row>
          </AllowanceBox>
        </Flex>

        <Divider gap={20} />

        <Row>
          <Col col-xs={"auto"}>
            <Row rowGap>
              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="Present Days"
                  name="Present Days"
                  type="text"
                  placeholder="Type Here..."
                  readOnly
                />
              </Col>
              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="Casual Leave"
                  name="total_leave"
                  type="text"
                  placeholder="Type Here..."
                  readOnly
                />
              </Col>
              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="Medical Leave"
                  name="total_leave"
                  type="text"
                  placeholder="Type Here..."
                  readOnly
                />
              </Col>
              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="Medical leave"
                  name="medical_leave"
                  type="text"
                  placeholder="Type Here..."
                />
              </Col>

              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="Privilege leave"
                  name="Privilege leave"
                  type="text"
                  placeholder="Type Here..."
                />
              </Col>

              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="Sanction leave"
                  name="Sanction leave"
                  type="text"
                  placeholder="Type Here..."
                />
              </Col>

              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="Payable Weekly Off Days"
                  name="Payable Weekly Off Days"
                  type="text"
                  placeholder="Type Here..."
                />
              </Col>

              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="OT Hour"
                  name="OT Hour"
                  type="text"
                  placeholder="Type Here..."
                />
              </Col>

              <Col sm={12} md={4} lg={3}>
                <InputField
                  fullWidth
                  label="Remarks"
                  name="Remarks"
                  type="text"
                  placeholder="Type Here..."
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Dialog>
      {/* UploadImportModal */}
    </>
  );
};

export default OtTracking;
